module.exports = __webpack_public_path__ + "media/images/card_deck_edit_EN-c32e5396.jpg";